const getBrowserType = function () {
  let ua = window.navigator.userAgent.toLowerCase()
  let browserType = ''
  if (/kachabrowser/.test(ua)) {
    // 酒咔嚓 app
    browserType = 'kachabrowser'
  } else if (/jdapp/.test(ua)) {
      // 京东 app
      browserType = 'jdapp'
  } else if (/micromessenger/.test(ua)) {
    // 微信
    browserType = 'weixin'
  } else if (/qq/.test(ua)) {
    if (/nettype/.test(ua)) {
      // QQ
      browserType = 'qq'
    } else {
      // QQ浏览器
      browserType = 'qqbrowser'
    }
  } else if (/baiduboxapp/.test(ua)) {
    // 百度应用
    browserType = 'baiduboxapp'
  } else if (/sogou/.test(ua)) {
    // 搜狗
    browserType = 'sogou'
  } else if (/ucbrowser/.test(ua)) {
    // UC浏览器
    browserType = 'ucbrowser'
  } else if (/chrome/.test(ua)) {
    // 谷歌浏览器
    browserType = 'chrome'
  } else if (/opera/.test(ua)) {
    browserType = 'opera'
  } else if (/firefox/.test(ua)) {
    browserType = 'firefox'
  } else if (/safari/.test(ua)) {
    browserType = 'safari'
  } else if (/compatible/.test(ua) && /msie/.test(ua)) {
    browserType = 'ie'
  } else if (/trident/.test(ua)) {
    browserType = 'edge'
  } else {
    browserType = 'other'
  }
  return browserType
}

module.exports = getBrowserType



// WEBPACK FOOTER //
// ./src/utils/getBrowserType.js